// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.pageNotFound_dashboard__0TP5u {
  width: calc(100% - 320px);
  position: relative;
  left: 310px;
  padding: 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.pageNotFound_dashboardContain__yud5h {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_dashboardContain__yud5h,
.pageNotFound_bodythemedark__izgZ0 .pageNotFound_dashboard__0TP5u,
.pageNotFound_bodythemedark__izgZ0 .pageNotFound_cont2__EI6Fp {
  background-Color: #0f1824;
}

.pageNotFound_top_header__CbMdW .pageNotFound_top_header_inner__Yqzkv {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.pageNotFound_cont2__EI6Fp {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.pageNotFound_footer__81doL {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.pageNotFound_bodythemelight__9C0zJ {
  background-color: #fff;
  padding-top: 90px;
}

.pageNotFound_bodythemedark__izgZ0 {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.pageNotFound_headerthemelight__nogyG {
  background-color: #fff;
}

.pageNotFound_headerthemedark__n03qG {
  background-color: #132337;
}

.pageNotFound_top_header__CbMdW {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.pageNotFound_menuthemelight__uQTtA {
  background-color: #fff;
}

.pageNotFound_menuthemedark__9swPb {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.pageNotFound_menulinklight__iCnH0 span {
  color: #666666 !important;
}

.pageNotFound_menulinklight__iCnH0 a {
  color: #CBCBCB !important;
}

.pageNotFound_menulinklight__iCnH0:hover span, .pageNotFound_menulinklight__iCnH0:hover a {
  color: #fff !important;
}

.pageNotFound_menulinkdarkSelected__GzD0b {
  background-color: #1c2e45;
  color: #3b82f6;
}

.pageNotFound_menuthemelight__uQTtA .pageNotFound_menulinklightSelected__qDVX8 {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #131F43;
}

.pageNotFound_menulinkdark__Fcqkt {
  color: #92afd3 !important;
}

.pageNotFound_menulinklight__iCnH0:hover {
  color: #fff !important;
  background-color: #131F43;
}

.pageNotFound_menulinklight__iCnH0 .pageNotFound_sub_arrow__nFY2M svg path {
  stroke: #CBCBCB !important;
}

.pageNotFound_menulinklight__iCnH0:hover .pageNotFound_sub_arrow__nFY2M svg path {
  stroke: #fff !important;
}

.pageNotFound_menulinkdark__Fcqkt .pageNotFound_sub_arrow__nFY2M svg path {
  stroke: #92afd3 !important;
}

.pageNotFound_menulinkdark__Fcqkt:hover .pageNotFound_sub_arrow__nFY2M svg path {
  stroke: #fff !important;
}

.pageNotFound_menulinkdark__Fcqkt:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.pageNotFound_headinglight__aU2u3 {
  color: #60677e;
}

.pageNotFound_headingdark__pzwfB {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.pageNotFound_searchboxlight__Pp7Yy {
  background-color: #fff;
  border: none;
}

.pageNotFound_searchboxdark__xEfh- {
  background-color: #132337;
  color: #fff;
  border: none;
}

.pageNotFound_searchboxdark__xEfh-::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.pageNotFound_tableheadlight__6cDbl {
  background-color: #131F43;
  border-radius: 5px 5px 0px 0px;
}

.pageNotFound_tableheadlight__6cDbl th {
  color: #fff;
}

thead .pageNotFound_tableheadlight__6cDbl th:first-child,
thead .pageNotFound_tableheaddark__o6KpO th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .pageNotFound_tableheadlight__6cDbl th:last-child,
thead .pageNotFound_tableheaddark__o6KpO th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.pageNotFound_table__8c81O.pageNotFound_table-borderless__S2usL {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.pageNotFound_tableheaddark__o6KpO {
  background-color: #132337;
  color: #fff;
}

.pageNotFound_table-borderless__S2usL tr:nth-child(even) {
  background-color: #F9FAFB;
}

.pageNotFound_table-borderless__S2usL .pageNotFound_left-section__nYWHy {
  padding-top: 10px;
}

.pageNotFound_tablebodylight__zbx9W td,
.pageNotFound_tablebodydark__5345K td {
  padding: 0.5rem 1rem !important;
  line-height: 45px;
}

.pageNotFound_tablebodylight__zbx9W {
  background-color: #fff;
}
.pageNotFound_tablebodylight__zbx9W:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.pageNotFound_tablebodydark__5345K {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.pageNotFound_tablebodydark__5345K:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.pageNotFound_paginationlight__5-m1Y {
  color: #60677e !important;
  font-size: 13px !important;
}

.pageNotFound_paginationdark__0djFl {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.pageNotFound_formthemelight__BnzOv {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.pageNotFound_formthemedark__k43uf {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.pageNotFound_formthemedark__k43uf ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.pageNotFound_viewformlight__rI6NH {
  background-color: #f3f6f9;
}

.pageNotFound_permissionboxlight__kVZ9Z {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.pageNotFound_permissionboxdark__eLcKA {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.pageNotFound_errormsgclr__X2vxQ {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.pageNotFound_graphclrlight__kk-pp {
  background-color: #fff;
}

.pageNotFound_graphclrdark__HSI92 {
  background-color: #132337;
}

/* 
Counter theme
*/
#pageNotFound_card1bglight__V5atL {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#pageNotFound_card1bgdark__lYsBK {
  background: #392f28;
}

#pageNotFound_card2bglight__mXhao {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#pageNotFound_card2bgdark__E-LAP {
  background: #1c3238;
}

#pageNotFound_card3bglight__LxOFZ {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#pageNotFound_card3bgdark__yN\\+MZ {
  background: #3a2434;
}

#pageNotFound_card4bglight__g176N {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#pageNotFound_card4bgdark__huDb5 {
  background: #2f264f;
}

#pageNotFound_card1bgdark__lYsBK a, #pageNotFound_card1bgdark__lYsBK p,
#pageNotFound_card2bgdark__E-LAP a, #pageNotFound_card2bgdark__E-LAP p,
#pageNotFound_card3bgdark__yN\\+MZ a, #pageNotFound_card3bgdark__yN\\+MZ p,
#pageNotFound_card4bgdark__huDb5 a, #pageNotFound_card4bgdark__huDb5 p {
  color: #fff;
}

/* 
Action button theme
*/
.pageNotFound_actionbtnlight__MOwsn {
  color: rgba(70, 71, 91, 0.8705882353);
}

.pageNotFound_actionbtnlight__MOwsn:hover {
  cursor: pointer;
}

.pageNotFound_actionbtndark__W4WOX {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.pageNotFound_profiledropdownlight__67WTq {
  background-color: #fff;
}

.pageNotFound_profiledropdowndark__WyM1p {
  background-color: #151521;
}

.pageNotFound_settingsection__1httz #pageNotFound_addform__qq8S5.pageNotFound_formthemedark__k43uf .pageNotFound_savebtn__AxlOn {
  background-color: #3b82f6;
  color: #fff;
}

#pageNotFound_addform__qq8S5.pageNotFound_formthemedark__k43uf .pageNotFound_savebtn__AxlOn {
  background-color: #3b82f6;
  color: #fff;
}

.pageNotFound_profile_conatiner__tORcl {
  border-radius: 5px !important;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_ag-theme-alpine__O7mDj .pageNotFound_ag-row__2yX73 {
  background: #000 !important;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_formbtn__2z\\+SQ {
  background-color: #3b82f6;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_formbtn__2z\\+SQ:hover {
  background-color: #2563eb;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_resetbtn__lAzFq {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_resetbtn__lAzFq:hover {
  background-color: #3b82f6;
}

.pageNotFound_headingdark__pzwfB span {
  background-color: #132337;
}

.pageNotFound_resetbtn__lAzFq {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131F43;
  color: #131F43;
  min-width: 113px;
}

.pageNotFound_resetbtn__lAzFq:hover,
.pageNotFound_resetbtn__lAzFq:active,
.pageNotFound_resetbtn__lAzFq:focus {
  background-color: #131F43;
  color: #fff;
}

.pageNotFound_addBtn__rwE\\+l {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.pageNotFound_addbtnlight__zWxU7 {
  background-color: #38A169;
}

.pageNotFound_addbtndark__U2iQU {
  background-color: #3b82f6;
}

.pageNotFound_addbtndark__U2iQU:hover {
  background-color: #2563eb;
}

.pageNotFound_formthemedark__k43uf label {
  color: #92afd3;
}

.pageNotFound_addBtn__rwE\\+l svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.pageNotFound_addBtn__rwE\\+l:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.pageNotFound_cust_addBtn__TnOt1.pageNotFound_addBtn__rwE\\+l svg {
  top: 2px;
}

.pageNotFound_deleteBtn__XLyVi {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.pageNotFound_deleteBtn__XLyVi {
  min-width: 130px;
  height: 50px;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.pageNotFound_deleteBtn__XLyVi:active, .pageNotFound_deleteBtn__XLyVi:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.pageNotFound_deleteBtn__XLyVi svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.pageNotFound_deleteBtn__XLyVi:hover,
.pageNotFound_deleteBtn__XLyVi:active,
.pageNotFound_deleteBtn__XLyVi:focus {
  background-color: #F94747;
  color: #fff;
  border: none;
}

.pageNotFound_confirmBtn__fwsol {
  background-color: #131F43;
}

.pageNotFound_confirmBtn__fwsol:hover,
.pageNotFound_confirmBtn__fwsol:active,
.pageNotFound_confirmBtn__fwsol:focus {
  background-color: #131F43;
}

.pageNotFound_confirmBtn__fwsol svg {
  top: 0;
}

.pageNotFound_delPopContainer__jG\\+ZJ .pageNotFound_modal-body__F3rpo {
  padding: 25px;
  text-align: center;
}

.pageNotFound_delPopContainer__jG\\+ZJ .pageNotFound_delet_icon__wLV3L {
  margin-bottom: 11px;
}

.pageNotFound_delPopContainer__jG\\+ZJ p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.pageNotFound_arrowback__oGXcu svg {
  fill: #000;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_arrowback__oGXcu {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_arrowback__oGXcu svg {
  fill: #3b82f6;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_drpdwn_btn__pzqyu {
  background-color: #132337;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_empname__C\\+FQL {
  color: #92afd3 !important;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_navitemli__bTqs5 a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_tabnavli__0bRdR a.pageNotFound_settingsgeneral__6vqVQ,
.pageNotFound_bodythemedark__izgZ0 .pageNotFound_tabnavli__0bRdR a.pageNotFound_settingslinks__LBkg9:hover {
  background-color: #3b82f6;
  color: #fff;
}

.pageNotFound_bodythemedark__izgZ0 .pageNotFound_tabnavli__0bRdR a.pageNotFound_settingslinks__LBkg9 {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.pageNotFound_headerthemedark__n03qG .pageNotFound_dropdown_menu_contain__etG-Y {
  background-color: #1c2e45;
  color: #fff;
}

.pageNotFound_headerthemedark__n03qG .pageNotFound_dropdown_menu_contain__etG-Y ul li a,
.pageNotFound_headerthemedark__n03qG .pageNotFound_dropdown_menu_contain__etG-Y .pageNotFound_dropdown_item__N0zRo,
.pageNotFound_headerthemedark__n03qG .pageNotFound_dropdown_menu_contain__etG-Y .pageNotFound_dropdown_item__N0zRo h5 {
  color: #fff;
}

.pageNotFound_headerthemedark__n03qG .pageNotFound_dropdown_menu_contain__etG-Y ul li a:hover,
.pageNotFound_headerthemedark__n03qG .pageNotFound_dropdown_menu_contain__etG-Y .pageNotFound_dropdown_item__N0zRo:hover {
  background-color: #132337;
  color: #fff;
}

.pageNotFound_dropdown_item__N0zRo:active {
  background-color: #F5F6FA;
}

.pageNotFound_profile_arrrow_dwn__mJT4Q {
  stroke: #132337;
}

.pageNotFound_headerthemedark__n03qG .pageNotFound_profile_arrrow_dwn__mJT4Q {
  stroke: #fff;
}

.pageNotFound_dateinputbox1__NmeA9 input,
.pageNotFound_dateinputbox1__NmeA9 span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .pageNotFound_tableheadlight__6cDbl th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .pageNotFound_dashboard__0TP5u {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .pageNotFound_cont2__EI6Fp {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
     height: auto !important;
   }*/
}
@media only screen and (max-width: 767px) {
  .pageNotFound_sectionright__enb5k {
    float: unset !important;
  }
  .pageNotFound_dashboard__0TP5u {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .pageNotFound_cont2__EI6Fp {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
  }
  .pageNotFound_bodythemelight__9C0zJ, .pageNotFound_bodythemedark__izgZ0 {
    padding-top: 110px;
  }
}
@media (min-width: 576px) {
  .pageNotFound_exer_modal_contain__EGPxS .pageNotFound_modal-dialog__6f-OB {
    max-width: 1055px;
  }
  .pageNotFound_delPopContainer__jG\\+ZJ .pageNotFound_modal-dialog__6f-OB {
    max-width: 350px;
  }
}
#pageNotFound_notfoundbg__QT9Fg {
  height: 100vh;
}

.pageNotFound_centerbox__93O8u {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  color: #1d1d1d;
  align-items: center;
  height: max-content;
}

.pageNotFound_imgdiv__b7eTp {
  justify-content: center;
  display: flex;
}

.pageNotFound_pagenotimage__P-7Vt {
  width: 250px;
  height: 200px;
}

.pageNotFound_pagenotfoundhead__p8c3e {
  font-size: 30px;
  color: #28305f;
  text-align: center;
  margin-top: 10px;
}

.pageNotFound_pagenotfoundpara__sT4fn {
  font-size: 18px;
  color: #28305f;
  text-align: center;
}

.pageNotFound_btnsection__2I-9O {
  display: flex;
  justify-content: center;
}

.pageNotFound_gohomebtn__aPCJt {
  background-color: #28305f;
  color: #fff;
  border: none;
  padding: 6px 20px 6px 20px;
  border-radius: 6px;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/404/pageNotFound.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAkDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,aAhBiB;EAiBjB,kBAAA;EACA,2BAAA;EACA,yBA1FO;EA2FP,2BAAA;EACA,gBAAA;ACxEF;;AD0EA;EACE,yBAAA;EACA,yBAhGO;EAiGP,kBAAA;ACvEF;;ADyEA;;;EAGE,yBAlEoB;ACJtB;;ADwEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACrEF;;ADwEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBAxHO;EAyHP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;ACnEF;;AD4EA;EACE,YAAA;ACzEF;;AD4EA;EACE,sBA5FY;ACmBd;;AD4EA;;CAAA;AAGA;EACE,sBAnGY;EAoGZ,iBAAA;ACzEF;;AD2EA;EACE,yBAlHgB;EAmHhB,iBAAA;ACxEF;;AD2EA;;CAAA;AAGA;EACE,sBA/GY;ACuCd;;AD2EA;EACE,yBA9HgB;ACsDlB;;AD0EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACvEF;;AD0EA;;CAAA;AAGA;EACE,sBAnIY;AC4Dd;;ADyEA;EACE,yBAjJgB;AC2ElB;;ADyEA;;CAAA;AAGA;EACE,yBAAA;ACtEF;;ADyEA;EACE,yBAAA;ACtEF;;ADyEA;EACE,sBAAA;ACtEF;;ADyEA;EACE,yBAlKsB;EAmKtB,cA7KkB;ACuGpB;;ADwEA;EACE,sCAAA;EACA,sBAAA;EACA,yBA5Mc;ACuIhB;;ADwEA;EACE,yBAAA;ACrEF;;ADwEA;EACE,sBAAA;EACA,yBArNc;ACgJhB;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,0BAAA;ACrEF;;ADwEA;EACE,uBAAA;ACrEF;;ADwEA;EACE,yBArMsB;EAsMtB,WA7LY;ACwHd;;ADwEA;;CAAA;AAGA;EACE,cAjMe;AC4HjB;;ADwEA;EACE,cArMe;ACgIjB;;ADwEA;;CAAA;AAGA;EACE,sBA/MY;EAgNZ,YAAA;ACrEF;;ADwEA;EACE,yBA/NgB;EAgOhB,WArNY;EAsNZ,YAAA;ACrEF;;ADuEA;EACE,cAtNe;ACkJjB;;ADuEA;;CAAA;AAGA;EACE,yBA7Qc;EA8Qd,8BAAA;ACpEF;;ADsEA;EACE,WApOY;ACiKd;;ADqEA;;EAEE,0BAAA;AClEF;;ADoEA;;EAEE,0BAAA;ACjEF;;ADmEA;EACE,kBAAA;AChEF;;ADkEA;EACE,kBAAA;AC/DF;;ADiEA;EACE,oCAAA;EACA,gCAAA;AC9DF;;ADiEA;EACE,yBAlPkB;EAmPlB,WA3PY;AC6Ld;;ADgEA;EACE,yBAAA;AC7DF;;AD+DA;EACE,iBAAA;AC5DF;;AD8DA;;EAEE,+BAAA;EACA,iBAAA;AC3DF;;AD6DA;EACE,sBAzQY;AC+Md;AD4DE;EACE,yBAAA;EACA,YAAA;AC1DJ;;AD6DA;EACC,0CAAA;EACC,cA/Qe;ACqNjB;AD4DE;EACE,yCAAA;EACA,YAAA;AC1DJ;;AD8DA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,0BAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBA1SY;EA2SZ,yBAAA;EACA,qDAAA;AC1DF;;AD4DA;EACE,yBAvSkB;EAwSlB,yBAAA;EACA,eAAA;ACzDF;AD2DE;EACE,cAjTa;ACwPjB;;AD8DA;;CAAA;AAGA;EACE,yBAhUgB;ACqQlB;;AD8DA;EACE,yBAAA;EACA,yBAAA;AC3DF;;AD6DA;EACE,yBA/UoB;EAgVpB,yBAAA;AC1DF;;AD6DA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAnVY;ACyRd;;AD6DA;EACE,yBA/UkB;ACqRpB;;AD8DA;;CAAA;AAGA;EACE,iGAAA;EACA,sBAhWY;ACqSd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAzWY;AC8Sd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBAlXY;ACuTd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;EACE,gGAAA;EACA,sBA3XY;ACgUd;;AD8DA;EACE,mBAAA;AC3DF;;AD8DA;;;;EAIE,WAtYY;AC2Ud;;AD8DA;;CAAA;AAGA;EACE,qCAAA;AC3DF;;AD6DA;EACE,eAAA;AC1DF;;AD4DA;EACE,cAhZe;ACuVjB;;AD6DA;;CAAA;AAGA;EACE,sBAAA;AC1DF;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,yBApbkB;EAqblB,WApaY;AC0Wd;;AD4DA;EACE,yBAxbkB;EAyblB,WAxaY;AC+Wd;;AD4DA;EACE,6BAAA;ACzDF;;AD4DA;EACE,2BAAA;ACzDF;;AD4DA;EACE,yBArckB;AC4YpB;;AD4DA;EACE,yBAxcwB;AC+Y1B;;AD4DA;EACE,WA5bY;EA6bZ,6BAAA;EACA,yBAAA;ACzDF;;AD4DA;EACE,yBAndkB;AC0ZpB;;AD6DA;EACE,yBAldgB;ACwZlB;;AD6DA;EACE,eAAA;EACA,gBA/fc;EAggBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cA7fc;EA8fd,gBAAA;AC1DF;;AD4DA;;;EAGE,yBAngBc;EAogBd,WAvdY;AC8Zd;;AD4DA;EACE,gBAAA;EACA,YAAA;EACA,WA7dY;EA8dZ,yBAzfY;EA0fZ,YAAA;EACA,eAAA;EACA,gBAphBc;AC2dhB;;AD4DA;EACE,yBAhgBY;ACucd;;AD2DA;EACE,yBAzfkB;ACicpB;;AD0DA;EACE,yBA3fwB;ACoc1B;;AD0DA;EACE,cAjgBiB;AC0cnB;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACxDF;;AD2DA;EACE,WA1fY;EA2fZ,yBAthBY;EAuhBZ,YAAA;ACxDF;;AD2DA;EACE,QAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBA1hBW;EA2hBX,WAvgBY;EAwgBZ,eAAA;EACA,gBA5jBc;EA6jBd,YAAA;ACxDF;;AD2DA;EACE,gBAAA;EACA,YAAA;EACA,yBApiBW;EAqiBX,WAjhBY;EAkhBZ,eAAA;EACA,gBAtkBc;EAukBd,YAAA;ACxDF;;AD2DA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACxDF;;AD2DA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;ACxDF;;AD2DA;;;EAGE,yBA1jBW;EA2jBX,WAviBY;EAwiBZ,YAAA;ACxDF;;AD2DA;EACE,yBAzlBc;ACiiBhB;;AD2DA;;;EAGE,yBA/lBc;ACuiBhB;;AD2DA;EACE,MAAA;ACxDF;;AD6DA;EACE,aAAA;EACA,kBAAA;AC1DF;;AD6DA;EACE,mBAAA;AC1DF;;AD6DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC1DF;;AD6DA;EACE,UAAA;AC1DF;;AD6DA;EACE,yCA9lBc;EA+lBd,cAnmBkB;ACyiBpB;;AD6DA;EACE,aAvmBkB;AC6iBpB;;AD6DA;EACE,yBAnmBgB;ACyiBlB;;AD6DA;EACE,yBAAA;AC1DF;;AD6DA;EACE,6BAAA;EACA,yBAAA;EACA,WAlmBY;ACwiBd;;AD6DA;;EAEE,yBAxnBkB;EAynBlB,WAxmBY;AC8iBd;;AD4DA;EACE,6BAAA;EACA,yBAAA;EACA,WA7mBY;ACojBd;;AD4DA;EACE,yBA1nBsB;EA2nBtB,WAlnBY;ACyjBd;;AD4DA;;;EAGE,WAxnBY;AC+jBd;;AD4DA;;EAEE,yBAxoBgB;EAyoBhB,WA9nBY;ACqkBd;;AD4DA;EACE,yBAhrBO;ACunBT;;AD4DA;EACE,eAjpBgB;ACwlBlB;;AD4DA;EACE,YA1oBY;ACilBd;;AD4DA;;EAEE,sBAAA;ACzDF;;AD4DA,iBAAA;AAUA;EACE;IACE,gBAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;EClEF;EDoEA;IACE,2BAAA;IACA,gBAAA;EClEF;AACF;ADoEA;EACC;;KAAA;AChED;ADoEA;EACE;IACE,uBAAA;EClEF;EDoEA;IACE,6BAAA;EClEF;AACF;ADoEA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EClEF;EDoEA;IACE,kBAAA;EClEF;AACF;ADqEA;EACE;IACI,iBAAA;ECnEJ;EDqEA;IACI,gBAAA;ECnEJ;AACF;AApsBA;EACI,aAAA;AAssBJ;;AApsBA;EAEI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,cDkDU;ECjDV,mBAAA;EACA,mBAAA;AAssBJ;;AAnsBA;EACI,uBAAA;EACA,aAAA;AAssBJ;;AAnsBA;EACI,YAAA;EACA,aAAA;AAssBJ;;AApsBA;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAusBJ;;AArsBA;EACI,eAAA;EAEA,cAAA;EACA,kBAAA;AAusBJ;;AApsBA;EACI,aAAA;EACA,uBAAA;AAusBJ;;AArsBA;EACI,yBAAA;EACA,WDgBU;ECfV,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;AAwsBJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #131F43;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n$dark-active-blue : #3b82f6;\n$dark-light-blue : #92afd3;\n$addBtn-dark-blue : #3b82f6;\n$addBtn-dark-blue-hover : #2563eb;\n$backBtn-dark : #3b82f633;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131F43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 310px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinklight .sub_arrow svg path{\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path{\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path{\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 45px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover{\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark; \n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item, \n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input, \n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n\n}\n\n.modalStyleDark {\n  \n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) { \n /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 110px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"/src/styles/Variables/Variables.scss\";\n\n#notfoundbg{\n    height: 100vh;\n}\n.centerbox{\n  \n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    color: $black-color;\n    align-items: center;\n    height: max-content;\n}\n\n.imgdiv{\n    justify-content: center;\n    display: flex;\n}\n\n.pagenotimage{\n    width: 250px;\n    height: 200px;\n}\n.pagenotfoundhead{\n    font-size: 30px;\n    color: #28305f;\n    text-align: center;\n    margin-top: 10px;\n}\n.pagenotfoundpara{\n    font-size: 18px;\n     \n    color: #28305f;\n    text-align: center;\n}\n\n.btnsection{\n    display: flex;\n    justify-content: center;\n}\n.gohomebtn{\n    background-color: #28305f;\n    color: $white-color;\n    border: none;\n    padding: 6px 20px 6px 20px;\n    border-radius: 6px;\n    font-size: 14px;\n     \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `pageNotFound_dashboard__0TP5u`,
	"dashboardContain": `pageNotFound_dashboardContain__yud5h`,
	"bodythemedark": `pageNotFound_bodythemedark__izgZ0`,
	"cont2": `pageNotFound_cont2__EI6Fp`,
	"top_header": `pageNotFound_top_header__CbMdW`,
	"top_header_inner": `pageNotFound_top_header_inner__Yqzkv`,
	"footer": `pageNotFound_footer__81doL`,
	"bodythemelight": `pageNotFound_bodythemelight__9C0zJ`,
	"headerthemelight": `pageNotFound_headerthemelight__nogyG`,
	"headerthemedark": `pageNotFound_headerthemedark__n03qG`,
	"menuthemelight": `pageNotFound_menuthemelight__uQTtA`,
	"menuthemedark": `pageNotFound_menuthemedark__9swPb`,
	"menulinklight": `pageNotFound_menulinklight__iCnH0`,
	"menulinkdarkSelected": `pageNotFound_menulinkdarkSelected__GzD0b`,
	"menulinklightSelected": `pageNotFound_menulinklightSelected__qDVX8`,
	"menulinkdark": `pageNotFound_menulinkdark__Fcqkt`,
	"sub_arrow": `pageNotFound_sub_arrow__nFY2M`,
	"headinglight": `pageNotFound_headinglight__aU2u3`,
	"headingdark": `pageNotFound_headingdark__pzwfB`,
	"searchboxlight": `pageNotFound_searchboxlight__Pp7Yy`,
	"searchboxdark": `pageNotFound_searchboxdark__xEfh-`,
	"tableheadlight": `pageNotFound_tableheadlight__6cDbl`,
	"tableheaddark": `pageNotFound_tableheaddark__o6KpO`,
	"table": `pageNotFound_table__8c81O`,
	"table-borderless": `pageNotFound_table-borderless__S2usL`,
	"left-section": `pageNotFound_left-section__nYWHy`,
	"tablebodylight": `pageNotFound_tablebodylight__zbx9W`,
	"tablebodydark": `pageNotFound_tablebodydark__5345K`,
	"paginationlight": `pageNotFound_paginationlight__5-m1Y`,
	"paginationdark": `pageNotFound_paginationdark__0djFl`,
	"formthemelight": `pageNotFound_formthemelight__BnzOv`,
	"formthemedark": `pageNotFound_formthemedark__k43uf`,
	"viewformlight": `pageNotFound_viewformlight__rI6NH`,
	"permissionboxlight": `pageNotFound_permissionboxlight__kVZ9Z`,
	"permissionboxdark": `pageNotFound_permissionboxdark__eLcKA`,
	"errormsgclr": `pageNotFound_errormsgclr__X2vxQ`,
	"graphclrlight": `pageNotFound_graphclrlight__kk-pp`,
	"graphclrdark": `pageNotFound_graphclrdark__HSI92`,
	"card1bglight": `pageNotFound_card1bglight__V5atL`,
	"card1bgdark": `pageNotFound_card1bgdark__lYsBK`,
	"card2bglight": `pageNotFound_card2bglight__mXhao`,
	"card2bgdark": `pageNotFound_card2bgdark__E-LAP`,
	"card3bglight": `pageNotFound_card3bglight__LxOFZ`,
	"card3bgdark": `pageNotFound_card3bgdark__yN+MZ`,
	"card4bglight": `pageNotFound_card4bglight__g176N`,
	"card4bgdark": `pageNotFound_card4bgdark__huDb5`,
	"actionbtnlight": `pageNotFound_actionbtnlight__MOwsn`,
	"actionbtndark": `pageNotFound_actionbtndark__W4WOX`,
	"profiledropdownlight": `pageNotFound_profiledropdownlight__67WTq`,
	"profiledropdowndark": `pageNotFound_profiledropdowndark__WyM1p`,
	"settingsection": `pageNotFound_settingsection__1httz`,
	"addform": `pageNotFound_addform__qq8S5`,
	"savebtn": `pageNotFound_savebtn__AxlOn`,
	"profile_conatiner": `pageNotFound_profile_conatiner__tORcl`,
	"ag-theme-alpine": `pageNotFound_ag-theme-alpine__O7mDj`,
	"ag-row": `pageNotFound_ag-row__2yX73`,
	"formbtn": `pageNotFound_formbtn__2z+SQ`,
	"resetbtn": `pageNotFound_resetbtn__lAzFq`,
	"addBtn": `pageNotFound_addBtn__rwE+l`,
	"addbtnlight": `pageNotFound_addbtnlight__zWxU7`,
	"addbtndark": `pageNotFound_addbtndark__U2iQU`,
	"cust_addBtn": `pageNotFound_cust_addBtn__TnOt1`,
	"deleteBtn": `pageNotFound_deleteBtn__XLyVi`,
	"confirmBtn": `pageNotFound_confirmBtn__fwsol`,
	"delPopContainer": `pageNotFound_delPopContainer__jG+ZJ`,
	"modal-body": `pageNotFound_modal-body__F3rpo`,
	"delet_icon": `pageNotFound_delet_icon__wLV3L`,
	"arrowback": `pageNotFound_arrowback__oGXcu`,
	"drpdwn_btn": `pageNotFound_drpdwn_btn__pzqyu`,
	"empname": `pageNotFound_empname__C+FQL`,
	"navitemli": `pageNotFound_navitemli__bTqs5`,
	"tabnavli": `pageNotFound_tabnavli__0bRdR`,
	"settingsgeneral": `pageNotFound_settingsgeneral__6vqVQ`,
	"settingslinks": `pageNotFound_settingslinks__LBkg9`,
	"dropdown_menu_contain": `pageNotFound_dropdown_menu_contain__etG-Y`,
	"dropdown_item": `pageNotFound_dropdown_item__N0zRo`,
	"profile_arrrow_dwn": `pageNotFound_profile_arrrow_dwn__mJT4Q`,
	"dateinputbox1": `pageNotFound_dateinputbox1__NmeA9`,
	"sectionright": `pageNotFound_sectionright__enb5k`,
	"exer_modal_contain": `pageNotFound_exer_modal_contain__EGPxS`,
	"modal-dialog": `pageNotFound_modal-dialog__6f-OB`,
	"notfoundbg": `pageNotFound_notfoundbg__QT9Fg`,
	"centerbox": `pageNotFound_centerbox__93O8u`,
	"imgdiv": `pageNotFound_imgdiv__b7eTp`,
	"pagenotimage": `pageNotFound_pagenotimage__P-7Vt`,
	"pagenotfoundhead": `pageNotFound_pagenotfoundhead__p8c3e`,
	"pagenotfoundpara": `pageNotFound_pagenotfoundpara__sT4fn`,
	"btnsection": `pageNotFound_btnsection__2I-9O`,
	"gohomebtn": `pageNotFound_gohomebtn__aPCJt`
};
export default ___CSS_LOADER_EXPORT___;
